module.exports = __webpack_public_path__ + "static/media/customerServiceimg5.17f6942c.png";